import { PrinterIcon } from '@heroicons/react/16/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import Skeleton from 'react-loading-skeleton'

const PrintButton = forwardRef(function PrintButton(
  {
    onClick,
    text = 'Report drucken',
    className,
    disabled = false,
    isLoading = false,
    ...props
  },
  ref
) {
  if (isLoading) {
    return <Skeleton height={44} width={160} />
  }

  return (
    <button
      ref={ref}
      title={text}
      className={clsx(
        'flex h-11 flex-row items-center gap-x-1 rounded-full border border-softGrey px-5',
        'hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-buttonSecondaryBlue focus:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <PrinterIcon className='size-4 text-buttonSecondaryBlue' />
      <span className='text-sm font-medium text-buttonSecondaryBlue'>
        {text}
      </span>
    </button>
  )
})

PrintButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool
}

export default PrintButton
